<template>
  <section>
    <h2 class="hdg_order01"><i></i>マニュアルダウンロード</h2>
    <p>{{ message }}</p>
    <div class="btn_download">
      <button class="btn btn-primary" @click="dlOrderFormatFileHandler">
        {{ downloadbtn }}
      </button>
      <button class="btn btn-primary" @click="dlOrderInstructionsFileHandler">
        CSVフォーマットマニュアル
      </button>
    </div>
    <h2 class="hdg_order01 mt40"><i></i>CSVアップロード</h2>

    <!-- <input type="file" name="file" id="input-file-now" class="dropify" /> -->
    <file-drop name="file" v-model="selectedFile"></file-drop>

    <div v-if="uploadMessage" class="alert alert-danger mt-4">
      {{ uploadMessage }}
    </div>

    <div class="btn-center">
      <button
        class="btn btn-primary"
        @click="ulOrderCsvHandler"
        :disabled="selectedFile === null"
      >
        ファイルを取り込む
      </button>
    </div>

    <template v-if="isUploaded">
      <div id="uploaded">
        <div class="err_file mt30 mb30" v-if="hasErrorMessages()">
          <ul>
            <template v-for="order in uploadOrders">
              <li :key="order.row_no" v-if="order.err_msg">
                <a
                  class="txt_err"
                  href="javascript:void(0);"
                  @click="scrollTo(order)"
                  v-html="$options.filters.nl2br(order.err_msg)"
                ></a>
              </li>
              <li :key="order.row_no" v-if="order.warn_msg">
                <a
                  class="txt_warning"
                  href="javascript:void(0);"
                  @click="scrollTo(order)"
                  v-html="$options.filters.nl2br(order.warn_msg)"
                ></a>
              </li>
            </template>
          </ul>
        </div>

        <div class="table-responsive mt-5">
          <table class="table table-bordered bg-white tbl_file01 text-nowrap">
            <thead>
              <tr class="bg-tbl-head text-white text-center">
                <th></th>
                <th style="min-width: 10em;" v-for="i in uploadColumn" :key="i">
                  {{ uploadHeader[`field${i.toString().padStart(3, 0)}`] }}
                </th>
                <th>[変換後]お届け先コード</th>
                <th>[変換後]お届け先名</th>
                <th>[変換後]お届け先郵便番号</th>
                <th>[変換後]お届け先住所</th>
                <th>[変換後]製品コード</th>
                <th>[変換後]品番名</th>
                <th>[変換後]規格名</th>
                <th>[変換後]色名</th>
                <th>[変換後]需要家コード</th>
                <th>[変換後]需要家名</th>
              </tr>
            </thead>
            <tbody>
              <tr
                :id="`order${order.row_no}`"
                v-for="order in uploadOrders"
                :key="order.row_no"
                :class="{ 'bg-tbl-orange': hasErrorRow(order) }"
              >
                <td>
                  <label
                    v-if="!order.err_fg"
                    class="custom-control custom-checkbox"
                    ><input
                      type="checkbox"
                      class="custom-control-input"
                      v-model="selectedInputNo"
                      :value="order.input_no"/><span
                      class="custom-control-indicator"
                    ></span
                  ></label>
                </td>
                <td
                  class="td_file_input"
                  v-for="i in uploadColumn"
                  :key="i"
                  :class="txtColor(order, i)"
                >
                  {{ order[`field${i.toString().padStart(3, 0)}`] }}
                </td>
                <td class="td_file_input">
                  {{ order.delivery_cd }}
                </td>
                <td class="td_file_input">
                  {{ order.dlcompany_na }}
                </td>
                <td class="td_file_input">
                  {{ order.dlpost_no }}
                </td>
                <td class="td_file_input">
                  {{ order.dladdress_na }}
                </td>
                <td class="td_file_input">
                  {{ order.item_cd }}
                </td>
                <td class="td_file_input">
                  {{ order.part_na }}
                </td>
                <td class="td_file_input">
                  {{ order.stand_na }}
                </td>
                <td class="td_file_input">
                  {{ order.color_na }}
                </td>
                <td class="td_file_input">
                  {{ order.clcompany_cd }}
                </td>
                <td class="td_file_input">
                  {{ order.clcompany_na }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h2 class="hdg_order01 mt40"><i></i>取込結果</h2>

        <div>
          <table class="table table-bordered bg-white tbl_master01 text-center">
            <tbody>
              <tr>
                <th class="bg-tbl-light">取込件数</th>
                <td>{{ captureCount }}</td>
                <th class="bg-tbl-light">選択件数</th>
                <td>{{ selectedLength }}件</td>
                <th class="bg-tbl-light">エラー件数</th>
                <td>{{ errCount }}</td>
                <th class="bg-tbl-light">要確認件数</th>
                <td>{{ warnCount }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="alert alert-danger" v-if="confirmMessage">
          {{ confirmMessage }}
        </div>

        <div class="btn-center">
          <button class="btn btn-info btn-lg" @click="resetData">
            取り消し
          </button>
          <button
            type="button"
            @click="moveToConfirmPage"
            class="btn btn-order btn-lg"
          >
            確認
          </button>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
import {
  store as loginUser,
  mutations as loginUserMutations
} from "../../../../store/LoginUser";
// import { mutations as BootstrapMutations } from "../../../../store/Bootstrap";

import { store as FileOrderStore } from "../../../../store/FileOrder";

export default {
  data() {
    return {
      message: "",
      confirmMessage: "",

      downloadbtn: "",
      cdcredeptlist: [],
      selectedFile: null,
      // uploadedSelectedFile: null,
      isUploaded: false,

      uploadFileName: "",
      uploadMessage: "",
      uploadHeader: [],
      uploadColumn: 0,
      uploadOrders: [],

      selectedInputNo: []
    };
  },
  computed: {
    uploadedLength() {
      return this.uploadOrders.length;
    },
    warningLength() {
      return this.uploadOrders.filter(el => {
        for (let i = 1; i <= this.uploadColumn; i += 1) {
          if (el[`field${i.toString().padStart(3, 0)}_worn_di`]) {
            return true;
          }
        }
        return false;
      }).length;
    },
    errorLength() {
      return this.uploadOrders.filter(el => el.err_fg).length;
    },
    selectedLength() {
      return this.selectedInputNo.length;
    },
    captureCount: {
      get() {
        return FileOrderStore.captureCount;
      },
      set(newVal) {
        FileOrderStore.captureCount = newVal;
      }
    },
    errCount: {
      get() {
        return FileOrderStore.errCount;
      },
      set(newVal) {
        FileOrderStore.errCount = newVal;
      }
    },
    warnCount: {
      get() {
        return FileOrderStore.warnCount;
      },
      set(newVal) {
        FileOrderStore.warnCount = newVal;
      }
    }
  },
  watch: {
    selectedFile: function(val, oldval) {
      if (val != oldval) {
        if (FileOrderStore.selectedFile != this.selectedFile) {
          FileOrderStore.selectedFile = this.selectedFile;
        }
      }
    }
  },
  async beforeMount() {
    const response = await this.getInitDataHandler();
    if (response.responseData.return != "0") {
      this.redirectToLogin();
      return;
    }

    // Set Login User Info
    loginUserMutations.setUserInfo(
      this.getAsteriaFirst(response.responseData, "loginUserInfoData")
    );
    if (!loginUser.info.auth_order_file) {
      this.submitAsteria(
        "Order",
        "loadHTML_forOrder",
        {},
        "/tab/order-simple",
        "/order/#/tab/order-simple"
      );
      return;
    }

    this.message = response.responseData.message;
    this.downloadbtn = response.responseData.downloadbtn;
    this.cdcredeptlist = this.getAsteriaArray(
      response.responseData,
      "cdcredeptlist"
    );

    this.uploadHeader = FileOrderStore.uploadHeader;
    this.uploadColumn = FileOrderStore.uploadColumn;
    this.uploadOrders = FileOrderStore.uploadOrders;
    this.uploadFileName = FileOrderStore.uploadFileName;
    this.selectedInputNo = FileOrderStore.selectedInputNo;
    this.selectedFile = FileOrderStore.selectedFile;
    FileOrderStore.denpyou_no = "";

    FileOrderStore.order_screen_ptn_di =
      response.responseData.order_screen_ptn_di;

    if (this.uploadFileName) {
      this.isUploaded = true;
    }

    this.addHookBeforeSubmitAsteria(() => {
      if (
        FileOrderStore.uploadOrders.length ||
        FileOrderStore.selectedFile != null
      ) {
        return window.confirm(
          "注文が完了しておりません。\n注文内容が消去されますが、よろしいでしょうか？"
        );
      }

      return true;
    });
  },
  methods: {
    /**
     * Get initial data from ASTERIA
     */
    async getInitDataHandler() {
      const response = await this.postAsteria("FileOrder", "getInitData");

      return response;
    },

    async ulOrderCsvHandler() {
      this.clearData();
      // BootstrapMutations.showLoading();

      const reader = new FileReader();
      reader.onload = async e => {
        const response = await this.postAsteria("FileOrder", "ulOrderCsv", {
          csvFile: e.target.result,
          csvFileName: this.selectedFile.name
        });
        // BootstrapMutations.hideLoading();

        if (response.responseData.return != 0) {
          if (response.responseData.return != 9) {
            window.alert("CSVアップロードに失敗しました");
          }
          this.uploadMessage = response.responseData.message;
          return;
        }

        this.isUploaded = true;
        this.uploadHeader = response.responseData.header;
        this.uploadColumn = parseInt(response.responseData.columns, 10);
        this.uploadOrders = this.getAsteriaArray(
          response.responseData,
          "fileOrderList"
        );
        this.uploadFileName = response.responseData.filename;

        this.uploadOrders.forEach(order => {
          if (!order.err_fg) {
            this.selectedInputNo.push(order.input_no);
          }
        });

        this.captureCount = response.responseData.captureCount;
        this.errCount = response.responseData.errCount;
        this.warnCount = response.responseData.warnCount;
        // this.uploadedSelectedFile = this.selectedFile;
        this.selectedFile = null;

        this.$nextTick(() => {
          const targetField = document.querySelector("#uploaded");
          if (targetField) {
            // targetField.scrollIntoView({
            //   behavior: "smooth",
            //   block: "center"
            // });
            this.$perfectScrollbar.scrollTo(targetField);
          }
        });

        FileOrderStore.uploadHeader = this.uploadHeader;
        FileOrderStore.uploadColumn = this.uploadColumn;
        FileOrderStore.uploadOrders = this.uploadOrders;
        FileOrderStore.uploadFileName = this.uploadFileName;
        FileOrderStore.selectedInputNo = this.selectedInputNo;
      };
      reader.readAsDataURL(this.selectedFile);
    },

    moveToConfirmPage() {
      if (this.selectedInputNo.length <= 0) {
        window.alert("少なくとも1つはチェックを入れて下さい");
        return;
      }

      FileOrderStore.uploadHeader = this.uploadHeader;
      FileOrderStore.uploadColumn = this.uploadColumn;
      FileOrderStore.uploadOrders = this.uploadOrders;
      FileOrderStore.uploadFileName = this.uploadFileName;
      FileOrderStore.selectedInputNo = this.selectedInputNo;
      // FileOrderStore.selectedFile = this.uploadedSelectedFile;

      this.$router.push({ name: "order-file-confirm" });
    },

    async dlOrderFormatFileHandler() {
      const response = await this.postAsteria(
        "FileOrder",
        "dlOrderFormatFile",
        {}
      );

      if (response.responseData.return != 0) {
        if (response.responseData.return != 9) {
          window.alert("フォーマットファイルの取得に失敗しました");
        }
        // this.confirmMessage = response.responseData.message;
        return;
      }

      this.$downloadFile(
        response.responseData.file_na,
        response.responseData.formatFile,
        "application/vnd.ms-excel"
      );
    },

    async dlOrderInstructionsFileHandler() {
      const response = await this.postAsteria(
        "FileOrder",
        "dlOrderInstructionsFile",
        {}
      );

      if (response.responseData.return != 0) {
        if (response.responseData.return != 9) {
          window.alert("フォーマットファイルの取得に失敗しました");
        }
        // this.confirmMessage = response.responseData.message;
        return;
      }

      this.$downloadFile(
        response.responseData.file_na,
        response.responseData.instructionsFile,
        "application/vnd.ms-excel"
      );
    },

    clearData() {
      this.isUploaded = false;
      this.uploadMessage = "";
      this.uploadHeader = [];
      this.uploadColumn = 0;
      this.uploadOrders = [];
      this.uploadFileName = "";
      this.selectedInputNo = [];
    },

    resetData() {
      this.clearData();

      this.selectedFile = null;
      // this.uploadedSelectedFile = null;

      FileOrderStore.uploadHeader = [];
      FileOrderStore.uploadColumn = [];
      FileOrderStore.uploadOrders = [];
      FileOrderStore.uploadFileName = "";
      FileOrderStore.selectedInputNo = [];

      this.scrollTo();
    },

    hasError() {
      let flag = false;

      this.uploadOrders.some(order => {
        if (this.hasErrorRow(order)) {
          flag = true;
          return true;
        }
      });

      return flag;
    },

    hasErrorMessages() {
      let flag = false;

      this.uploadOrders.some(order => {
        if (order.err_msg || order.warn_msg) {
          flag = true;
          return true;
        }
      });

      return flag;
    },

    hasErrorRow(order) {
      for (let i = 1; i <= this.uploadColumn; i += 1) {
        const key = `field${i.toString().padStart(3, 0)}_err_di`;
        if (order[key]) {
          return true;
        }
      }

      return false;
    },

    hasWornRow(order) {
      for (let i = 1; i <= this.uploadColumn; i += 1) {
        const key = `field${i.toString().padStart(3, 0)}_worn_di`;
        if (order[key]) {
          return true;
        }
      }

      return false;
    },

    scrollTo(order) {
      let target;
      if (order) {
        target = document.querySelector(`#order${order.row_no}`);
      } else {
        target = document.querySelector(`.tab_matome`);
      }

      if (!target) {
        return;
      }

      // target.scrollIntoView({
      //   behavior: "smooth",
      //   block: "start"
      // });
      this.$perfectScrollbar.scrollTo(target);
    },

    txtColor: function(order, col) {
      if (1 == order[`field${col.toString().padStart(3, 0)}_err_di`]) {
        return "txt_err";
      } else if (1 == order[`field${col.toString().padStart(3, 0)}_worn_di`]) {
        return "txt_warning";
      }
    }
  }
};
</script>
